import { mapState } from "vuex";
import { PLAN_NO } from "@/contants/plan";

export default () => {

  return {
    computed: {
      ...mapState("account", {
        shopInfo: "shopInfo",
      }),
      ...mapState("downgrade", {
        choosedPlan: state => state.choosedPlan,
      }),
      isEnterpriseToBuild() {
        return this.shopInfo.plan == PLAN_NO.ENTERPRISE && this.choosedPlan == PLAN_NO.BUILD;
      },
      isEnterpriseToOptimize() {
        return this.shopInfo.plan == PLAN_NO.ENTERPRISE && this.choosedPlan == PLAN_NO.OPTIMIZE;
      },
      isOptimizeToBuild() {
        return this.shopInfo.plan == PLAN_NO.OPTIMIZE && this.choosedPlan == PLAN_NO.BUILD;
      },
      isAdvancedToBuild() {
        return this.shopInfo.plan == PLAN_NO.ADVANCED && this.choosedPlan == PLAN_NO.BUILD;
      },
    },
  }
};
